<script>
  import { computed, nextTick, ref } from '@nuxtjs/composition-api'
  import { cartGetters } from '@/composables/propeller/getters'
  import { useCart } from '@/composables/propeller/useCart'

  export default {
    props: {
      size: {
        type: String,
        default: ''
      }
    },
    setup (props, { emit }) {
      const addingCoupon = ref(false)
      const loading = ref(false)
      const input = ref(null)

      const error = ref(null)
      const couponInput = ref(null)

      const { applyCoupon, cart, removeCoupon } = useCart()

      const coupon = computed(() => cart.value ? cartGetters.getAppliedCoupon(cart.value)?.code : undefined)

      const hasCouponApplied = computed(() => {
        return !!coupon.value
      })

      const setCouponFeedback = (isSuccess) => {
        if (!isSuccess) {
          return 'Kon coupon code niet toevoegen aan winkelwagen'
        }
        return null
      }

      const apply = async () => {
        loading.value = true

        try {
          await applyCoupon({
            couponCode: couponInput.value
          }).then(() => {
            error.value = setCouponFeedback(!!coupon.value)
          })

          loading.value = false
        } catch (err) {
          console.error('error applying coupon', err)
          setCouponFeedback(false)
        }

        couponInput.value = null
        addingCoupon.value = false
      }

      const remove = async () => {
        await removeCoupon({ currentCart: cart.value })
      }

      const addCoupon = () => {
        addingCoupon.value = true
      }

      const focusInput = () => {
        nextTick(() => {
          input.value && input.value.$el.querySelector('input').focus()
        })
      }

      return {
        input,
        coupon,
        loading,
        hasCouponApplied,
        couponInput,
        addCoupon,
        remove,
        focusInput,
        apply,
        error,
        addingCoupon
      }
    }
  }
</script>

<template>
  <div>
    <transition
      :duration="100"
      name="fade"
      mode="out-in"
      @after-enter="focusInput"
    >
      <e-button
        v-if="hasCouponApplied"
        type="tertiary"
        :size="size"
        reversed
        @click="remove"
      >
        <span>
          Kortingscode verwijderen ({{ coupon }})
        </span>
      </e-button>
      <e-button
        v-else-if="!addingCoupon"
        type="tertiary"
        :size="size"
        reversed
        @click="addCoupon"
      >
        <span>
          Kortingscode invoeren
        </span>
      </e-button>
      <form
        v-else
        class="flex space-x-2"
        @submit.prevent="apply"
      >
        <e-input
          #error
          ref="input"
          v-model="couponInput"
          placeholder="Kortingscode"
        />
        <e-button-loading
          :loading="loading"
          type="primary"
        >
          Toevoegen
        </e-button-loading>
      </form>
    </transition>
    <div
      v-if="error"
      class="error-container mt-2"
    >
      {{ error }}
    </div>
  </div>
</template>

<style scoped>

</style>
